import Avatar from './Avatar';

export default function MyAvatar({ avatarSrc, ...other }) {
  return <Avatar alt={'admin avatar'} src={avatarSrc || '/images/admin-avatar.jpeg'} {...other} />;
}
